import api from 'js/api'
export const getAccountInfoByUserId = (id) =>
  api('GET', `v2/accounts/account_info/${id}`).then((res) => res.response)
